import {useRef, useState} from "react";
import {useSelector} from "react-redux";

import {useScrollableListItemTracking} from "@pg-mono/hooks";

import {IRPStore} from "../../../app/rp_reducer";
import {notifyBugsnag} from "../../../errors/bugsnag/notify_bugsnag";
import {useGetPropertyDetailQuery} from "../../../property/api/get_property_detail";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {checkHasVerifiedPhone} from "../../../user/utils/check_has_verified_phone";
import {hitMultileadRecommendationShown} from "../../tracking/lead/hit_multilead_recommendation_shown";
import {MultileadVersion} from "../../types/lead/MultileadVersion";
import {RecommendationSource} from "../../types/lead/RecommendationSource";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";

interface IUseApplicationMultiLeadPropertyListParams {
    mainPropertyId?: IPropertyDetail["id"];
    recommendedProperties: IRecommendedProperty[];
}

export const useApplicationMultiLeadPropertyList = (params: IUseApplicationMultiLeadPropertyListParams) => {
    const {mainPropertyId, recommendedProperties} = params;

    const [hoveredItemID, setHoveredItemID] = useState<null | number>(null);
    const listRef = useRef<HTMLDivElement>(null);
    const listWrapRef = useRef<HTMLUListElement>(null);
    const viewType = useSelector((store: IRPStore) => store.viewType.current);
    const {data: userProfile} = useGetUserProfileQuery();
    const hasVerifiedPhone = checkHasVerifiedPhone(userProfile);

    const {data: mainPropertyDetail, isLoading: isLoadingMainPropertyDetail} = useGetPropertyDetailQuery(mainPropertyId!, {
        skip: !mainPropertyId
    });

    const ignoredCn = useScrollableListItemTracking({
        scrollableListRef: listRef,
        directAncestorListRef: listWrapRef,
        listElementTrackingIdDatasetName: "trackId",
        handleListItemTrackingHit: (trackingId) => {
            hitMultileadRecommendationShown({
                recommendationId: trackingId,
                recommendationType: ApplicationMultiLeadRecommendationType.PROPERTY,
                recommendationSource: RecommendationSource.DISTANCE,
                multileadVersion: MultileadVersion.RP_LIST_PROPERTY,
                viewType
            });
        },
        onError: (error) => {
            console.warn(error);
            notifyBugsnag(new Error(error), error);
        }
    });

    const onListItemHover = (itemID: number | null) => {
        setHoveredItemID(itemID);
    };

    const sortedRecommendations = [...recommendedProperties]
        .sort((a, b) => (a.price || 0) - (b.price || 0))
        .map((recommendedItem) => {
            const hasPriceComparison = hasVerifiedPhone && !!recommendedItem.price && !!mainPropertyDetail?.price;
            const hasAreaComparison = !!mainPropertyDetail?.area && !!recommendedItem.area;

            const recommendationAdvantages =
                hasPriceComparison || hasAreaComparison
                    ? {
                          priceDifference: hasPriceComparison ? mainPropertyDetail.price! - recommendedItem.price! : 0,
                          areaDifference: hasAreaComparison ? mainPropertyDetail.area - recommendedItem.area : 0
                      }
                    : undefined;

            return {property: recommendedItem, recommendationAdvantages};
        });

    return {
        hoveredItemID,
        onListItemHover,
        listRef,
        listWrapRef,
        viewType,
        hasVerifiedPhone,
        mainPropertyDetail,
        isLoadingMainPropertyDetail,
        ignoredCn,
        sortedRecommendations
    };
};
import {useRef, useState} from "react";
import {useSelector} from "react-redux";

import {useScrollableListItemTracking} from "@pg-mono/hooks";

import {IRPStore} from "../../../app/rp_reducer";
import {notifyBugsnag} from "../../../errors/bugsnag/notify_bugsnag";
import {useGetPropertyDetailQuery} from "../../../property/api/get_property_detail";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {checkHasVerifiedPhone} from "../../../user/utils/check_has_verified_phone";
import {hitMultileadRecommendationShown} from "../../tracking/lead/hit_multilead_recommendation_shown";
import {MultileadVersion} from "../../types/lead/MultileadVersion";
import {RecommendationSource} from "../../types/lead/RecommendationSource";
import {ApplicationMultiLeadRecommendationType} from "../../types/multi_lead/ApplicationMultiLeadRecommendationType";

interface IUseApplicationMultiLeadPropertyListParams {
    mainPropertyId?: IPropertyDetail["id"];
    recommendedProperties: IRecommendedProperty[];
}

export const useApplicationMultiLeadPropertyList = (params: IUseApplicationMultiLeadPropertyListParams) => {
    const {mainPropertyId, recommendedProperties} = params;

    const [hoveredItemID, setHoveredItemID] = useState<null | number>(null);
    const listRef = useRef<HTMLDivElement>(null);
    const listWrapRef = useRef<HTMLUListElement>(null);
    const viewType = useSelector((store: IRPStore) => store.viewType.current);
    const {data: userProfile} = useGetUserProfileQuery();
    const hasVerifiedPhone = checkHasVerifiedPhone(userProfile);

    const {data: mainPropertyDetail, isLoading: isLoadingMainPropertyDetail} = useGetPropertyDetailQuery(mainPropertyId!, {
        skip: !mainPropertyId
    });

    const ignoredCn = useScrollableListItemTracking({
        scrollableListRef: listRef,
        directAncestorListRef: listWrapRef,
        listElementTrackingIdDatasetName: "trackId",
        handleListItemTrackingHit: (trackingId) => {
            hitMultileadRecommendationShown({
                recommendationId: trackingId,
                recommendationType: ApplicationMultiLeadRecommendationType.PROPERTY,
                recommendationSource: RecommendationSource.DISTANCE,
                multileadVersion: MultileadVersion.RP_LIST_PROPERTY,
                viewType
            });
        },
        onError: (error) => {
            console.warn(error);
            notifyBugsnag(new Error(error), error);
        }
    });

    const onListItemHover = (itemID: number | null) => {
        setHoveredItemID(itemID);
    };

    const sortedRecommendations = [...recommendedProperties]
        .sort((a, b) => (a.price || 0) - (b.price || 0))
        .map((recommendedItem) => {
            const hasPriceComparison = hasVerifiedPhone && !!recommendedItem.price && !!mainPropertyDetail?.price;
            const hasAreaComparison = !!mainPropertyDetail?.area && !!recommendedItem.area;

            const recommendationAdvantages =
                hasPriceComparison || hasAreaComparison
                    ? {
                          priceDifference: hasPriceComparison ? mainPropertyDetail.price! - recommendedItem.price! : 0,
                          areaDifference: hasAreaComparison ? mainPropertyDetail.area - recommendedItem.area : 0
                      }
                    : undefined;

            return {property: recommendedItem, recommendationAdvantages};
        });

    return {
        hoveredItemID,
        onListItemHover,
        listRef,
        listWrapRef,
        viewType,
        hasVerifiedPhone,
        mainPropertyDetail,
        isLoadingMainPropertyDetail,
        ignoredCn,
        sortedRecommendations
    };
};
